import { GetCoverageTypePayload, GetCoverageTypeReturn } from "@/api/types";
import { request } from "./request";

export async function getCoverageTypeAPI(payload: GetCoverageTypePayload): Promise<GetCoverageTypeReturn> {
  return await request({
    url: "/coverage_type/get",
    method: "POST",
    data: payload,
  });
};
